// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qqkgxhzzkljiskxymvkn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFxa2d4aHp6a2xqaXNreHltdmtuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM5NjExMTEsImV4cCI6MjA1OTUzNzExMX0.Vw-iYzX0blODY6jCr8SAx7TbtNtEhVYZkPvI2UEnmtw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);